import VenueDefinition, {VideoRoomInfo} from "../../VenueDefinition";
import Phaser from "phaser";
import ConferenceGame from "../../../ConferenceGame";
import BootScene from "../../BootScene";
import {ChatMessage, LiveAppContext, OverlayMessage, PlayerAndInfo} from "../../LiveWorldScene";
import {ConferenceEvent} from "../../../DataTypes";
import DancePartyWorldScene from "./DancePartyWorldScene";
import TutorialWorldScene from "../../tutorial/TutorialWorldScene";
import BaseWorldScene, {PlayerProfileInfo} from "../../BaseWorldScene";
import Breakout from "../../Breakout";
import SessionizeDataProvider from "../../SessionizeDataProvider";
import SesstionizeWorldScene from "../../SessionizeWorldScene";
import FurnitureProvider from "../../features/FurnitureProvider";
import {EventIntf} from "../../../ServerTypes";
import {IGameContext} from "../../../GameContext";

export default class MainVenue extends VenueDefinition {
    sessionizeData: SessionizeDataProvider
    furnitureProvider = new FurnitureProvider()
    currentScenes: Phaser.Scene[] = <Phaser.Scene[]>[]

    constructor(event: EventIntf) {
        super(event)
        this.sessionizeData = new SessionizeDataProvider(this.venueDataProvider)
    }

    videoAdminPanel(forRoom: string):VideoRoomInfo {
        const currentScene = this.findCurrentScene(forRoom)

        if(currentScene instanceof SesstionizeWorldScene){
            const sc = currentScene as SesstionizeWorldScene
            if(sc.videoKey.startsWith("room_stream_")){
                const roomNumber = sc.videoKey.substring("room_stream_".length)
                return new VideoRoomInfo(sc.videoKey, `Room ${roomNumber} Stream`)
            }
        }
        return super.videoAdminPanel(forRoom)
    }

    private findCurrentScene(forRoom: string): BaseWorldScene | null {
        for(let s of this.currentScenes){
            if(s instanceof BaseWorldScene && (s as BaseWorldScene).worldKey === forRoom){
                return s
            }
        }

        return null
    }

    callRefresh() {
        super.callRefresh();
        this.sessionizeData.callRefresh()
    }

    preload(scene: Phaser.Scene): void {
        scene.load.plugin('rexcirclemaskimageplugin', 'https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/master/dist/rexcirclemaskimageplugin.min.js', true);

        // map tiles
        scene.load.image('maptiles', '/assets/maps/tileset-32px-extruded.png');
        scene.load.image('ground', '/assets/maps/tilesets/ground-extruded.png');
        scene.load.image('structures', '/assets/maps/tilesets/structures-extruded.png');
        scene.load.image('woods', '/assets/maps/tilesets/woods-extruded.png');

        scene.load.image('wall', '/assets/maps/tutorial/wall.png');
        scene.load.image('arrows', '/assets/maps/tutorial/arrows.png');

        // map in json format
        scene.load.tilemapTiledJSON('tutorial', '/assets/maps/main/tutorial.json');
        scene.load.tilemapTiledJSON('hall', '/assets/maps/main/hall.json');
        scene.load.tilemapTiledJSON('chatRoom', '/assets/maps/main/chat-room.json');
        scene.load.tilemapTiledJSON('secretRoom', '/assets/maps/main/secret-room.json');
        scene.load.tilemapTiledJSON('vipRoom', '/assets/maps/main/vip-room.json');
        scene.load.tilemapTiledJSON('entryway', '/assets/maps/main/entryway.json');
        scene.load.tilemapTiledJSON('sessionRoom', '/assets/maps/main/session-room.json');

        // our two characters
        scene.load.spritesheet('player', '/assets/RPG_assets.png', {
            frameWidth: 32,
            frameHeight: 32
        });

        scene.load.spritesheet('tv', '/assets/TV_animation.png', {
            frameWidth: 50,
            frameHeight: 50
        });

        // chat bubbles
        scene.load.spritesheet('chatBubbles', '/assets/bubble_assets.png', {
            frameWidth: 26,
            frameHeight: 24
        });

        scene.load.audio('clunk', [
            '/assets/audio/clunk.ogg',
            '/assets/audio/clunk.mp3'
        ]);

        scene.load.audio('mario', [
            '/assets/audio/mario2.ogg',
            '/assets/audio/mario2.mp3'
        ]);

        scene.load.audio('dance', [
            '/assets/audio/dance.ogg',
            '/assets/audio/dance.mp3'
        ]);

        scene.load.bitmapFont("gamefont", "/assets/gamefont.png", "/assets/gamefont.fnt");
        scene.load.bitmapFont("gamefont_small", "/assets/gamefont_small.png", "/assets/gamefont_small.fnt");
        scene.load.bitmapFont("gamefont_small_gray", "/assets/gamefont_small_gray.png", "/assets/gamefont_small.fnt");

        // our two characters
        scene.load.spritesheet('dancers', '/assets/Dancing_assets.png', {
            frameWidth: 56,
            frameHeight: 56
        });

        scene.load.image('talkRadius', '/assets/images/talkRadius.png');
        scene.load.image('empty', '/assets/images/empty.png');

        this.furnitureProvider.preload(scene)
    }

    postload(scene: Phaser.Scene) {

    }

    createScenes(gameHost: ConferenceGame): Phaser.Scene[] {
        let gameWrapper = new ConferenceGameWrapper(gameHost);
        this.currentScenes = [
            new BootScene(gameWrapper, this, "tutorial", "firstWorld"),
            new TutorialWorldScene(
                "tutorial",
                "tutorial",
                false,
                gameWrapper,
                this),
            new BaseWorldScene(
                "entryway",
                "entryway",
                false,
                gameWrapper,
                this),
            new SesstionizeWorldScene(
                "firstWorld",
                "hall",
                "main_stream",
                false,
                gameWrapper,
                this),
            new SesstionizeWorldScene(
                "chatWorld",
                "chatRoom",
                "main_stream",
                false,
                gameWrapper,
                this),
            new DancePartyWorldScene(
                "secretRoom",
                "secretRoom",
                false,
                gameWrapper,
                this),
            new SesstionizeWorldScene(
                "vipRoom",
                "vipRoom",
                "main_stream",
                false,
                gameWrapper,
                this),
            new SesstionizeWorldScene(
                "session_room_1",
                "sessionRoom",
                "room_stream_1",
                false,
                gameWrapper,
                this),
            new SesstionizeWorldScene(
                "session_room_2",
                "sessionRoom",
                "room_stream_2",
                false,
                gameWrapper,
                this),
            new SesstionizeWorldScene(
                "session_room_3",
                "sessionRoom",
                "room_stream_3",
                false,
                gameWrapper,
                this),
            new SesstionizeWorldScene(
                "session_room_4",
                "sessionRoom",
                "room_stream_4",
                false,
                gameWrapper,
                this),
            new Breakout("breakout", gameWrapper)
        ]

        return this.currentScenes
    }
}

export class ConferenceGameWrapper implements LiveAppContext {
    currentUserId: number
    selectedEvent: ConferenceEvent;
    gameContext: IGameContext;

    constructor(public cg: ConferenceGame) {
        this.currentUserId = cg.props.appContext.currentUser.id
        this.selectedEvent = cg.props.selectedEvent as ConferenceEvent
        this.gameContext = cg.context as IGameContext
    }

    getGameOverlayMessage(): string | null {
        return this.cg.props.gameOverlayMessage
    }

    setGameOverlayMessage(messag: OverlayMessage): void {
        this.cg.props.setGameOverlayMessage(messag)
    }

    getVideoChatRoomName(): string | null {
        return this.cg.props.videoChatRoomName
    }

    showPlayerInfo(info: PlayerProfileInfo, callback?: () => void): void {
        if (this.cg.props.showPlayerInfo) {
            this.cg.props.showPlayerInfo(info, callback)
        }
    }

    startTalking(key: string): void {
        this.cg.props.startTalking(key)
    }

    cancelTalking() {
        this.cg.props.cancelTalking()
    }

    isAudioActive(): boolean {
        return this.cg.props.appContext.audioActive;
    }

    setSendMessageCallback(callback: (message: string) => void): void {
        this.cg.props.sendMessageCallback.callback = callback
    }

    showMessage(message: ChatMessage, playerInfo: PlayerAndInfo): void {
        this.cg.props.showMessage(message, playerInfo)
    }

    hideVideoChat(): void {
        this.cg.props.hideVideoChat()
    }

    showVideoChat(chatName: string): void {
        this.cg.props.showVideoChat(chatName)
    }

    setTwilioToken(token: any): void {
        this.cg.context.setTwilioToken(token)
    }
}
